import { CSSProperties, ReactNode } from "react";

/** The `ComponentItem` component properties. */
export interface ComponentItemProps {

  /** The component item class name. */
  readonly className?: string;

  /** The component item style. */
  readonly style?: CSSProperties;

  /** The item children. */
  readonly children?: ReactNode;

  /**
   * Indicates whether the item is disabled. If not specified defaults to `false`.
   */
  readonly disabled?: boolean;
}

/** A single item for the `Menu` component which can contain arbitary children. */
export const ComponentItem = (_: ComponentItemProps): ReactNode => {
  return null;
};
